import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import React from 'react';
import { Route } from 'react-router';

export const routes$ = {
    List: AsyncPageRender(() => pageModule(import('./View/default'))),
};

function Router() {
    return (
        <>
            <Route exact path={'/contact'} component={ProtectedRoute(routes$.List)} />
        </>
    );
}

export default Router;
